// extracted by mini-css-extract-plugin
module.exports = {"original":"original--DiscountedPrice-components__22aoE","discounted":"discounted--DiscountedPrice-components__2aQHj"};